import {useState} from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import Cleave from 'cleave.js/react';

import notSet from "shared/utils/notSet";


function TextInput(
    {
        required,
        value: propValue,
        touched: propTouched,
        onChange, onBlur,
        patternOptions,
        rows,
        className,
        ...extraProps
    },
) {
    const [stateValue, setValue] = useState();
    const [stateTouched, setTouched] = useState(false);
    const value = propValue || stateValue;
    const touched = propTouched || stateTouched;

    const error = required && notSet(value) && "Required";

    const props = {
        className: classnames(className, {
            'Valid': touched && !error,
            'Error': touched && error,
        }),
        required: required,
        value: value,
        onChange: event => {
            setValue(event.target.value);
            onChange && onChange(event.target.value);
        },
        onBlur: (...args) => {
            setTouched(true);
            onBlur && onBlur(...args);
        },
        ...extraProps,
    };

    return <>
        {patternOptions
            ? <Cleave options={patternOptions} {...props} />
            : rows > 1
                ? <textarea rows={rows} {...props}/>
                : <input {...props}/>
        }
        <div className={"ErrorList"}>
            {touched && error}&nbsp;
        </div>
    </>;
}

TextInput.propTypes = {
    required: PropTypes.bool,
    value: PropTypes.string,
    onChange: PropTypes.func,
    patternOptions: PropTypes.any,
    rows: PropTypes.number,
};

TextInput.defaultProps = {
    type: 'text',
    required: false,
    rows: 1,
};

export default TextInput;
